import * as CONST from '../../../const/jianding'
export default {
    CONST() {
        return CONST
    },
    getTabs(state){
        let {categoryTabs} = state;
        return function(id){
            let obj = {};
            if(categoryTabs){
                categoryTabs.forEach((item) => {
                    if(item.id === +id ){
                        obj = item
                    }
                });
            }
            return obj
        }
    },
    getAppraisers(state, _, rootState){
        let {info} = rootState['account'] || {};
        return function(type){
            let {appraisers} = state;
            if(type === 'my'){
                return appraisers.myAppraiser;
            } else {
                let arr = [];
                //选择鉴定师时过滤自己
                if(appraisers.appraisers && appraisers.appraisers.length){
                    arr = appraisers.appraisers.filter((item) => {
                        return item.aid !== info.uid
                    });
                }
                return arr //appraisers.appraisers;
            }
        }
    },
    getAppraisersList(state){
        return function(id){
            let {appraiserList} = state;
            if(appraiserList && appraiserList[id]){
                return  appraiserList[id]
            } else {
                return  []
            }
        }
    },

    getOrders(state){
        return function (status){
            let list = state.orders || [];
            if(status > 0){
                let arr = list.filter((item) => {
                    return item.status === status
                });
                return arr
            } else {
                return list
            }

        }
    },
    getOrderDetail(state){
        return state.orderDetail
    },
    getFinishOrders(state){
        return state.finishOrders
    },
    getAuthenticatedList(state){
        return state.authenticatedList
    },
    appraiserInfo(state) {
        return state.appraiserInfo.appraiser || null
    },
    userTotal (state) {
        let userTotal = state.appraiserInfo.userTotal || null
        return userTotal
    },
    appraiserTotal (state) {
        let appraisersTotal  = state.appraiserInfo.appraisersTotal  || null
        return appraisersTotal
    },
    cfgPeriods (state) {
        return state.jdConfig.periods   || {}
    },
    cfgTrend (state) {
        return state.jdConfig.trend     || {}
    },
    cfgService (state) {
        return state.jdConfig.service   || {}
    },
    cfgIsReal (state) {
        return state.jdConfig.isReal   || {}
    },
    cfgSpeed (state) {
        return state.jdConfig.speed     || {}
    },
    getTakeInfo (state) {
        return state.takeInfo           || {}
    },
    getTakeList (state) {
        return state.takeInfo.list      || []
    },
    getMoneyLog (state) {
        return state.moneyLog           || []
    },

}